export default __webpack_public_path__ + "static/media/ad-img.af898f18.jpg";